/*
 * Timeora - defilement automatique continu du carrousel d'avis Judge.me
 * (.jdgm-widget.jdgm-testimonials-carousel .jdgm-testimonials-container)
 *
 * HISTORIQUE (v3, 08/10) : l'ancienne version pilotait le défilement en JS pur
 * (requestAnimationFrame qui écrivait container.scrollLeft à chaque frame),
 * ce qui entrait en conflit avec scroll-snap et bloquait le défilement de façon
 * permanente. Depuis la v3, le défilement est une animation CSS pure
 * (@keyframes, voir tm-global.css), exactement comme sections/marquee-bar.liquid :
 * translation continue en boucle infinie, qui ne peut structurellement jamais se
 * figer puisqu'aucune lecture/écriture JS ne vient interférer avec elle à chaque
 * frame.
 *
 * RETOUR ARRIÈRE (10/10, demande Samy) : la v4 (09/10) ajoutait un clic sur la
 * carte pour ouvrir la fiche produit correspondante dans un nouvel onglet. Samy a
 * testé : ça ne fonctionnait pas, et il ne veut de toute façon plus de ce
 * comportement - l'avis est déjà lisible directement dans la carte, inutile de
 * rediriger ailleurs. Toute la logique de clic + l'indicateur visuel associé
 * (tm-global.css) sont retirés ci-dessous. Le carrousel redevient un simple
 * défilement où le texte est juste visible, sans rien de cliquable sur la carte.
 *
 * NOUVEAU (10/10, demande Samy) : deux flèches de navigation (précédent/suivant)
 * sont injectées sous le carrousel. Le widget Judge.me a ses propres flèches
 * natives (.jdgm-arrows--bottom, window.jdgmPreviousCard/jdgmNextCard) mais elles
 * sont conçues pour son carrousel natif à une carte à la fois en position
 * absolue/opacité - pas pour notre rail CSS multi-cartes dupliqué en boucle
 * infinie. Les utiliser telles quelles casserait l'indexation interne de Judge.me
 * (cartes déplacées + clonées). On les laisse donc masquées (voir tm-global.css)
 * et on injecte nos propres boutons, avec notre propre logique de navigation.
 *
 * Le widget Judge.me rend un nombre de cartes variable par produit, et PEUT
 * re-rendre son contenu (skeleton puis contenu final, pagination interne...) en
 * remplaçant les enfants du conteneur par de nouvelles cartes brutes. On ne peut
 * donc pas construire le rail "une seule fois pour toujours" avec un simple flag :
 * ensureTrack() est ré-entrant et reconstruit le rail (et réinjecte les flèches si
 * elles ont été supprimées par ce re-rendu) à chaque passage où des cartes
 * .jdgm-carousel-item brutes (non encore enveloppées) sont détectées comme
 * enfants directs du conteneur. Les écouteurs d'interaction (pause/reprise,
 * resize, IntersectionObserver) ne sont attachés qu'une seule fois par conteneur.
 *
 * NAVIGATION MANUELLE (flèches) : on n'agit jamais directement sur le rail animé
 * en CSS (.tm-reviews-track), pour ne jamais reproduire le conflit JS/animation
 * qui a causé le bug historique. On ajoute une couche indépendante
 * (.tm-reviews-shift) entre le conteneur et le rail : le rail continue de tourner
 * tout seul via son animation CSS (mise en pause pendant l'interaction, comme au
 * toucher), et la couche .tm-reviews-shift applique par-dessus un décalage
 * supplémentaire (transform + transition CSS) d'une largeur de carte à chaque
 * clic sur une flèche. Les deux transforms s'additionnent visuellement sans
 * jamais se marcher dessus.
 *
 * MODE MANUEL PERSISTANT (10/10, demande Samy) : un clic sur une flèche ne doit
 * plus reprendre le défilement automatique après un court délai - ce
 * comportement créait une reprise intempestive quelques centaines de ms après
 * le clic. Un clic sur une flèche active maintenant un mode manuel persistant
 * (container._tmManualMode = true, classe de pause ajoutée et jamais retirée
 * par un timeout). Seule la sortie puis ré-entrée du carrousel dans le viewport
 * (IntersectionObserver déjà en place plus bas) lève ce mode manuel et relance
 * le défilement automatique. Le comportement de pause au toucher/maintien
 * (pointerdown/pointerup, cf. initListeners) reste inchangé : pause temporaire
 * classique, sans rapport avec le mode manuel des flèches.
 *
 * Pause : pendant une interaction active (toucher / clic maintenu sur une carte,
 * OU navigation manuelle via une flèche) via `animation-play-state: paused`,
 * jamais au simple survol léger de la souris - on n'écoute donc pas
 * mouseenter/mouseleave, mais pointerdown/pointerup (couvre souris ET tactile de
 * façon unifiée).
 *
 * REPRISE INTELLIGENTE (10/10, demande Samy) : si l'utilisateur fait défiler la
 * PAGE (pas le carrousel) de sorte que le carrousel sorte du viewport, puis
 * remonte et le fait réapparaître, le défilement automatique doit avoir repris
 * normalement entre-temps - il ne doit jamais rester bloqué en pause juste parce
 * que l'utilisateur l'a quitté pendant une interaction. Un IntersectionObserver
 * par conteneur force la reprise (resume()) chaque fois que le carrousel redevient
 * visible, à condition qu'aucune interaction manuelle ne soit en cours à cet
 * instant précis (sinon on ne volerait pas le contrôle en pleine interaction).
 *
 * CORRECTIF (10/10, retest Samy) : le mode manuel persistant ne tenait pas
 * après un simple clic (sans maintien) sur une flèche - le défilement
 * reprenait dès le relâchement du bouton de la souris. Cause : le clic sur le
 * bouton de flèche émet aussi pointerdown puis pointerup sur le conteneur
 * (bubbling), qui déclenchait resume() du mécanisme de pause tactile/souris
 * classique (initListeners) - ce resume() retirait sans condition la classe
 * tm-reviews-paused, annulant l'effet de handleNav() posé juste avant par le
 * flag _tmManualMode. resume() vérifie maintenant _tmManualMode en premier et
 * ne touche plus à la classe de pause si le mode manuel est actif : seul
 * l'IntersectionObserver (sortie + ré-entrée du viewport) peut désormais
 * relancer l'auto-scroll après un clic sur une flèche.
 */
(function () {
  // Vitesse augmentée legerement (09/10, demande Samy) : +18% -> duree ~-15%
  // (72 -> 85 px/s). Ajustement fin volontaire, pas un changement radical :
  // le client a insiste pour que ça reste lisible, donc pas de saut plus grand.
  var SPEED_PX_PER_SEC = 85; // était 72
  var MIN_DURATION_S = 10; // était 12, réduit dans la même proportion (~-17%)

  function svgChevron() {
    return (
      '<svg viewBox="0 0 20 34" width="14" height="24" aria-hidden="true" focusable="false">' +
      '<path d="M16 6L6 17L16 28" fill="none" stroke="currentColor" stroke-width="2.5" ' +
      'stroke-linecap="round" stroke-linejoin="round"></path></svg>'
    );
  }

  // Crée (si absents) les deux boutons de navigation et les branche sur la
  // logique de décalage manuel. Appelée à chaque passage de ensureTrack : si
  // Judge.me a entièrement vidé le conteneur lors d'un re-rendu, les boutons
  // (qui sont des enfants directs du conteneur, au même niveau que le rail) ont
  // disparu avec le reste et sont donc recréés ici.
  function ensureArrows(container) {
    if (container.querySelector(':scope > .tm-reviews-nav')) return;

    var nav = document.createElement('div');
    nav.className = 'tm-reviews-nav';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'tm-reviews-arrow tm-reviews-arrow--prev';
    prevBtn.setAttribute('aria-label', "Avis précédent");
    prevBtn.innerHTML = svgChevron();

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'tm-reviews-arrow tm-reviews-arrow--next';
    nextBtn.setAttribute('aria-label', 'Avis suivant');
    nextBtn.innerHTML = svgChevron();

    // Lit le translateX réel actuellement appliqué par l'animation CSS sur le
    // rail (via la matrice de la transform calculée), peu importe où le cycle
    // d'animation en était au moment du clic. C'est la valeur manquante qui
    // causait le bug "retombe au milieu" : sans elle, le décalage manuel
    // repartait toujours de 0 indépendamment de la position réelle du rail
    // au moment de la pause, donc un retour "au début" (offset 0) ne
    // correspondait jamais à la première carte réelle, mais à un point
    // arbitraire du cycle d'animation en cours.
    function readTrackTranslateX(track) {
      var style = window.getComputedStyle(track);
      var transform = style.transform;
      if (!transform || transform === 'none') return 0;
      // matrix(a, b, c, d, tx, ty) -> on veut tx (5e valeur)
      var match = transform.match(/matrix\(([^)]+)\)/);
      if (!match) return 0;
      var parts = match[1].split(',').map(function (n) { return parseFloat(n); });
      return parts.length >= 5 ? -parts[4] : 0; // tx est négatif (translateX vers la gauche) -> on veut une valeur positive de décalage
    }

    function handleNav(direction) {
      // Première interaction manuelle de cette session de pause : on capture
      // la position RÉELLE du rail (figée par l'animation au moment du clic,
      // AVANT de neutraliser l'animation) comme nouveau point de référence,
      // puis on bascule le rail en contrôle manuel direct (animation
      // entièrement détachée, plus seulement "paused") pour que le décalage
      // manuel et la position affichée soient exactement la même chose - fini
      // le double-calcul (animation figée + couche de décalage par-dessus)
      // qui causait le saut vers une position arbitraire au moment du bouclage.
      if (!container._tmManualMode) {
        var track = container._tmTrack;
        if (track) {
          var singleSetWidth = track.scrollWidth / 2;
          var realOffset = readTrackTranslateX(track);
          if (singleSetWidth && isFinite(singleSetWidth)) {
            realOffset = ((realOffset % singleSetWidth) + singleSetWidth) % singleSetWidth;
          }
          track.classList.add('tm-reviews-manual-track');
          track.style.transform = 'translateX(' + -realOffset + 'px)';
          container._tmManualOffset = realOffset;
        }
      }
      shiftByOneCard(container, direction);
      // Mode manuel persistant : on ajoute la classe de pause et on arme le
      // flag _tmManualMode, sans jamais programmer de reprise par timeout.
      // Volontairement distinct de _tmInteracting (pointerdown/pointerup) :
      // un clic sur une flèche ne doit JAMAIS être levé par un pointerup qui
      // suit (ex: le clic lui-même), seul l'IntersectionObserver (sortie +
      // ré-entrée du viewport) peut lever ce mode et relancer l'auto-scroll.
      window.clearTimeout(container._tmNavResumeTimer);
      container._tmManualMode = true;
      container.classList.add('tm-reviews-paused');
    }

    prevBtn.addEventListener('click', function () {
      handleNav('prev');
    });
    nextBtn.addEventListener('click', function () {
      handleNav('next');
    });

    nav.appendChild(prevBtn);
    nav.appendChild(nextBtn);
    container.appendChild(nav);
  }

  // Décale directement le rail (.tm-reviews-track, désormais en contrôle
  // manuel - voir handleNav) d'une largeur de carte, avec un repli borné
  // (modulo la largeur d'un seul jeu de cartes) pour rester dans la zone
  // dupliquée valide du rail et ne jamais révéler un espace vide. Le
  // bouclage (ex: "next" sur la dernière carte) ramène donc exactement à la
  // position de départ de cette session de navigation manuelle - un vrai
  // défilement infini, jamais un saut vers une position arbitraire.
  function shiftByOneCard(container, direction) {
    var track = container._tmTrack;
    if (!track) return;

    var rawCard = track.querySelector('.jdgm-carousel-item');
    if (!rawCard) return;

    var cardWidth = rawCard.getBoundingClientRect().width;
    var gapPx = parseFloat(window.getComputedStyle(track).columnGap) || 20;
    var stepPx = cardWidth + gapPx;
    var singleSetWidth = track.scrollWidth / 2;
    if (!stepPx || !singleSetWidth || !isFinite(singleSetWidth)) return;

    var current = container._tmManualOffset || 0;
    var next = direction === 'next' ? current + stepPx : current - stepPx;
    // Repli dans [0, singleSetWidth) : garde le décalage borné indéfiniment,
    // quel que soit le nombre de clics, sans jamais sortir de la zone où le
    // contenu dupliqué garantit qu'il y a toujours quelque chose à afficher.
    next = ((next % singleSetWidth) + singleSetWidth) % singleSetWidth;

    container._tmManualOffset = next;
    track.style.transform = 'translateX(' + -next + 'px)';
  }

  // Construit (ou reconstruit) le rail à partir des cartes brutes actuellement
  // posées directement dans le conteneur par Judge.me. Ne fait rien si le
  // conteneur ne contient déjà que le rail (rien de brut à envelopper).
  function ensureTrack(container) {
    var rawItems = Array.prototype.slice.call(
      container.querySelectorAll(':scope > .jdgm-carousel-item')
    );

    if (rawItems.length) {
      // Si un ancien rail existe (contenu désormais obsolète, Judge.me a tout
      // re-rendu), on le retire : on repart des cartes brutes fraîchement reçues.
      var oldShift = container.querySelector(':scope > .tm-reviews-shift');
      if (oldShift) oldShift.remove();

      var track = document.createElement('div');
      track.className = 'tm-reviews-track';

      rawItems.forEach(function (item) {
        track.appendChild(item);
      });

      // Duplique le contenu UNE SEULE FOIS pour un bouclage invisible (translateX
      // 0 -> -50% dans le CSS correspond exactement à la largeur d'un jeu de cartes).
      rawItems.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      var shiftEl = document.createElement('div');
      shiftEl.className = 'tm-reviews-shift';
      shiftEl.appendChild(track);
      container.appendChild(shiftEl);

      container._tmShift = shiftEl;
      container._tmTrack = track;
      container._tmManualOffset = 0; // le rail est neuf : tout décalage manuel précédent est obsolète

      // Durée de l'animation = largeur d'un seul jeu de cartes / vitesse cible.
      function applyDuration() {
        var fullWidth = track.scrollWidth;
        var singleSetWidth = fullWidth / 2;
        if (!singleSetWidth || !isFinite(singleSetWidth)) return;
        var duration = Math.max(MIN_DURATION_S, singleSetWidth / SPEED_PX_PER_SEC);
        container.style.setProperty('--tm-reviews-duration', duration + 's');
      }

      applyDuration();
      // Recalcule après chargement des images (avatars, badges) qui peuvent changer
      // la largeur réelle des cartes une fois rendues.
      window.setTimeout(applyDuration, 500);
      window.setTimeout(applyDuration, 1500);

      container._tmApplyDuration = applyDuration;
    }

    // Les flèches sont des enfants directs du conteneur, au même niveau que le
    // rail (pas à l'intérieur) : un re-rendu Judge.me qui vide le conteneur les
    // fait disparaître elles aussi, donc on les revérifie à chaque passage,
    // indépendamment du fait qu'il y ait eu ou non de nouvelles cartes brutes.
    ensureArrows(container);
  }

  function initListeners(container) {
    if (container._tmListenersInit) return;
    container._tmListenersInit = true;

    // Recalcule la durée au redimensionnement (breakpoints desktop/tablette/
    // mobile changent la largeur des cartes via tm-global.css).
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (container._tmApplyDuration) container._tmApplyDuration();
      }, 200);
    });

    // --- Pause uniquement sur interaction active (toucher / clic maintenu, ou
    // navigation manuelle via une flèche), jamais au simple survol léger.
    // pointerdown/pointerup couvre souris et tactile de façon unifiée.
    // Exposées sur le conteneur (container._tmPause / _tmResume) pour que les
    // boutons de navigation (définis dans ensureArrows, portée différente)
    // puissent réutiliser exactement la même logique.
    function pause() {
      container.classList.add('tm-reviews-paused');
      container._tmInteracting = true;
    }
    function resume() {
      container._tmInteracting = false;
      // Priorité au mode manuel persistant (clic sur une flèche) : le
      // pointerup/touchend qui suit NATURELLEMENT un simple clic sur le
      // bouton (le navigateur émet pointerdown puis pointerup sur la cible,
      // qui bubbles jusqu'ici) ne doit jamais lever la pause posée par
      // handleNav(). Sinon le défilement reprenait dès le relâchement du
      // clic au lieu de rester arrêté jusqu'à la sortie+rentrée du viewport.
      if (container._tmManualMode) return;
      container.classList.remove('tm-reviews-paused');
    }
    container._tmPause = pause;
    container._tmResume = resume;

    container.addEventListener('pointerdown', pause);
    container.addEventListener('pointerup', resume);
    container.addEventListener('pointercancel', resume);
    container.addEventListener('pointerleave', resume);
    // Filet de sécurité pour les navigateurs/appareils sans Pointer Events.
    container.addEventListener('touchstart', pause, { passive: true });
    container.addEventListener('touchend', resume, { passive: true });
    container.addEventListener('touchcancel', resume, { passive: true });

    // --- Reprise intelligente : si le carrousel sort du viewport (l'utilisateur
    // fait défiler la PAGE, pas le carrousel) puis redevient visible, on force
    // la reprise du défilement auto - sauf si une interaction manuelle est
    // activement en cours à ce moment précis (on ne coupe jamais une
    // interaction en train de se produire). Ça évite qu'un pointerup/touchend
    // manqué (ex: le doigt quitte l'écran pendant que la page elle-même défile)
    // laisse le carrousel bloqué en pause indéfiniment.
    // C'est aussi le SEUL mécanisme qui lève le mode manuel persistant armé par
    // un clic sur une flèche (_tmManualMode) : tant que le carrousel ne sort pas
    // du viewport puis n'y revient pas, le défilement auto reste à l'arrêt.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !container._tmInteracting) {
              container._tmManualMode = false;
              // Rend la main à l'animation CSS : on retire le contrôle
              // manuel direct du rail (classe + transform inline) posé par
              // handleNav(), l'animation reprend alors son cycle normal.
              var track = container._tmTrack;
              if (track) {
                track.classList.remove('tm-reviews-manual-track');
                track.style.transform = '';
              }
              resume();
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(container);
    }
  }

  function initCarousel(container) {
    if (!container) return;
    initListeners(container);
    ensureTrack(container);
  }

  function scanAndInit() {
    document
      .querySelectorAll('.jdgm-widget.jdgm-testimonials-carousel .jdgm-testimonials-container')
      .forEach(initCarousel);
  }

  // Le widget Judge.me peut s'injecter après le DOMContentLoaded (app embed async).
  document.addEventListener('DOMContentLoaded', scanAndInit);
  window.addEventListener('load', scanAndInit);

  // MutationObserver anti-rafale : on observe tout le document (le widget peut
  // s'injecter n'importe où / n'importe quand, et Judge.me peut re-rendre son
  // contenu plus tard), mais on ne relance scanAndInit qu'après une courte
  // accalmie plutôt qu'à chaque mutation individuelle. ensureTrack() est
  // idempotent par construction : une fois le rail construit, le conteneur n'a
  // plus de carte brute en enfant direct (elles sont toutes dans .tm-reviews-track),
  // donc les passages suivants ne touchent plus du tout au DOM tant que Judge.me
  // n'insère pas de nouvelles cartes brutes (les flèches, elles, sont revérifiées
  // à chaque passage - voir ensureArrows).
  var OBSERVER_DEBOUNCE_MS = 200;
  var observerDebounceTimer = null;
  var observer = new MutationObserver(function () {
    window.clearTimeout(observerDebounceTimer);
    observerDebounceTimer = window.setTimeout(scanAndInit, OBSERVER_DEBOUNCE_MS);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Filet de securite : nouvelle tentative apres chargement differe de l'app.
  window.setTimeout(scanAndInit, 1500);
  window.setTimeout(scanAndInit, 4000);
})();
